module.exports = __webpack_public_path__ + "static/media/Layout10.d8fbe1f5.png";